















































import { Component, Vue } from "vue-property-decorator"
import { AppModule } from "@/store/modules/app"

@Component({
	name: "Header"
})

export default class extends Vue
{
	get headerMenu()
	{
		return AppModule.headerMenu
	}

	public toggleHeaderMenu()
	{
		AppModule.ToggleHeaderMenu()
	}

	public hideHeaderMenu()
	{
		AppModule.HideHeaderMenu()
	}

	public gotoRoute(routeName: string)
	{
		AppModule.HideHeaderMenu()

		if (this.$router.currentRoute.name !== routeName)
		{
			this.$router.push({ name: routeName })
		}
	}
}
